export default {
  browse: {
    title: "Explorar",
    sections: {
      advancedTools: "Ferramentas avançadas",
      freeTools: "Ferramentas gratuitas",
    },
    gamesOfPeriod: "Jogos do {{period}}",
    periods: {
      day: "dia",
      week: "semana",
    },
    gameCount_one: "{{count}} jogo",
    gameCount_other: "{{count}} jogos",
  },
};